import { ComponentView, ObservableArray, ViewGenerator, ViewModel } from "binder";
import { getAsBoolean } from "../utilities";
import { TabViewModel } from "./tab-viewModel"
import { TabItemBodyView } from "./tabItemContainer/tabItemBody-view";
import { TabItemContainerViewModel } from "./tabItemContainer/tabItemContainer-viewModel";

export class TabView extends ComponentView<TabViewModel>{
    GetViewUniqueId(): string {
        return "V-19FDE238-3CA1-481D-AE65-E57F1EA9F607"
    }
    loadHtml(): string {
        let element = require('./tab.html').default;
        let style = require('./tab.less');
        return element;
    }
    constructor() {
       super();
    }

    public set items(v: ObservableArray<ViewModel>) { this._items = v; } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set selecteditem(v: ViewModel) { this._selecteditem = v; } public get selecteditem(): ViewModel { return this._selecteditem;} private _selecteditem: ViewModel;
    public set internalItems(v: ObservableArray<TabItemContainerViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<TabItemContainerViewModel> { return this._internalItems;} private _internalItems: ObservableArray<TabItemContainerViewModel>;
    public set headerViewTemplate(v: Node) { this._headerViewTemplate = v; } public get headerViewTemplate(): Node { return this._headerViewTemplate;} private _headerViewTemplate: Node;
    public set fillwidth(v: boolean) { this._fillwidth = v; } public get fillwidth(): boolean { return this._fillwidth;} private _fillwidth: boolean;
    public set listoftabs(v: boolean) { this._listoftabs = getAsBoolean(v); } public get listoftabs(): boolean { return this._listoftabs;} private _listoftabs: boolean;

    private itemTemplateMapping:{[id:string]:Node}={};
    private placeHolder : HTMLDivElement;
    private prePlaceHolder : HTMLDivElement;
    templateSelector(vm){
        if(vm){
            let typeId = vm.getTypeId();
            let result = this.itemTemplateMapping[typeId];
            if(result)
                return ViewGenerator.GetNodeByTemplate(vm,result);
        }
        return null;
    }
    contentSelectorFunction(vm){
        let view = new TabItemBodyView();
        return view;
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains("tabheader")){
                this.headerViewTemplate = super.removeAsTemplate(node);
            }else if(node instanceof HTMLElement){
                for (let index = 0; index < node.classList.length; index++) {
                    const element = node.classList[index];
                    if(element.startsWith('template-')){
                        let template = super.removeAsTemplate(node);
                        let type = element.substring(9);
                        this.itemTemplateMapping[type]=template;
                        break;
                    }else if(element.startsWith('pre-placeholder')){
                        this.prePlaceHolder.append(node);
                    }else if(element.startsWith('placeholder')){
                        this.placeHolder.append(node);
                    }
                }
            }else{
            }
        })
    }
    public onRenderCompleted() {
        this.placeHolder = this.firstlevelElement.querySelector('.V-19FDE238-3CA1-481D-AE65-E57F1EA9F607.placeholder');
        this.prePlaceHolder = this.firstlevelElement.querySelector('.V-19FDE238-3CA1-481D-AE65-E57F1EA9F607.pre-placeholder');
    }
}
